export const tips = "SSORedirectPage.redirectingTips";
